import React from 'react';
import ReactDOM from 'react-dom/client';
import '@typedbootstrap/admin-styles/dist/css/styles.css';
import App from 'App';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { AuthProvider } from 'contexts';
import "./app.css";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ReduxProvider store={store}>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </ReduxProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
